import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import store from '@/store/index';

export class ContactApi {
  public async send(Subject: string, Message: string): Promise<boolean> {
    const MasterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;

    const response: AxiosResponse<
      AppResponse<boolean>
    > = await AuthorizedApiClient.post('/contactForm/Send', {
      Subject, Message, MasterAccountId,
    });
    const appResponse: AppResponse<boolean> = response.data;
    if (appResponse.IsSuccess) {
      return true;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
